import { Receipt, Wallet } from 'lucide-react';
import { EmptyState } from '../../components/common/EmptyState';
import { PageHeader } from '../../components/common/PageHeader';
import { StatCard } from '../../components/dashboard/StatCard';
import { useEffect, useState } from 'react';
import { getTransactions } from '../../firebase/firestore';
import { useTenant } from '../../hooks/useTenant';
import { formatCurrency } from '../../utils/currency';

export function FinancePage() {
  const { activeTenant, activeTenantId } = useTenant();
  const currency = activeTenant?.settings?.currency || 'KES';
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    if (!activeTenantId) {
      setTransactions([]);
      return;
    }
    getTransactions(activeTenantId)
      .then(setTransactions)
      .catch((error) => console.error('Unable to load finance transactions', error));
  }, [activeTenantId]);

  const revenue = transactions.filter((item) => item.type === 'revenue').reduce((sum, item) => sum + Number(item.amount || 0), 0);
  const expenses = transactions.filter((item) => item.type === 'expense').reduce((sum, item) => sum + Number(item.amount || 0), 0);

  return (
    <div className="page-stack">
      <PageHeader title="Finance" description="Foundation for revenue, outstanding balances and transactions." />
      <section className="stats-grid">
        <StatCard label="Revenue" value={formatCurrency(revenue, currency)} icon={Wallet} />
        <StatCard label="Expenses" value={formatCurrency(expenses, currency)} icon={Receipt} />
        <StatCard label="Transactions" value={String(transactions.length)} icon={Receipt} />
      </section>
      <section className="panel">
        <div className="panel-heading"><h2>Transactions</h2></div>
        {transactions.length ? <div className="panel-content"><p>{transactions.length} tenant-scoped financial record{transactions.length === 1 ? '' : 's'} loaded from Firebase.</p></div> : <EmptyState title="No financial records yet." message="Fees, invoices, payments, payouts and reports will build on tenant-scoped transactions." icon={Wallet} />}
      </section>
    </div>
  );
}
